function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import hasProperty from '@uppy/utils/lib/hasProperty';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import Tus from '@uppy/tus';
import Assembly from './Assembly.js';
import Client from './Client.js';
import AssemblyOptions, { validateParams } from './AssemblyOptions.js';
import AssemblyWatcher from './AssemblyWatcher.js';
import locale from './locale.js';
var packageJson = {
  "version": "3.1.1"
};

var sendErrorToConsole = function sendErrorToConsole(originalErr) {
  return function (err) {
    var error = new ErrorWithCause('Failed to send error to the client', {
      cause: err
    }); // eslint-disable-next-line no-console

    console.error(error, originalErr);
  };
};

var COMPANION_URL = 'https://api2.transloadit.com/companion'; // Regex matching acceptable postMessage() origins for authentication feedback from companion.

var COMPANION_ALLOWED_HOSTS = /\.transloadit\.com$/; // Regex used to check if a Companion address is run by Transloadit.

var TL_COMPANION = /https?:\/\/api2(?:-\w+)?\.transloadit\.com\/companion/;
/**
 * Upload files to Transloadit using Tus.
 */

var _rateLimitedQueue = /*#__PURE__*/_classPrivateFieldLooseKey("rateLimitedQueue");

var _getClientVersion = /*#__PURE__*/_classPrivateFieldLooseKey("getClientVersion");

var _attachAssemblyMetadata = /*#__PURE__*/_classPrivateFieldLooseKey("attachAssemblyMetadata");

var _createAssembly = /*#__PURE__*/_classPrivateFieldLooseKey("createAssembly");

var _createAssemblyWatcher = /*#__PURE__*/_classPrivateFieldLooseKey("createAssemblyWatcher");

var _shouldWaitAfterUpload = /*#__PURE__*/_classPrivateFieldLooseKey("shouldWaitAfterUpload");

var _reserveFiles = /*#__PURE__*/_classPrivateFieldLooseKey("reserveFiles");

var _onFileUploadURLAvailable = /*#__PURE__*/_classPrivateFieldLooseKey("onFileUploadURLAvailable");

var _findFile = /*#__PURE__*/_classPrivateFieldLooseKey("findFile");

var _onFileUploadComplete = /*#__PURE__*/_classPrivateFieldLooseKey("onFileUploadComplete");

var _onResult = /*#__PURE__*/_classPrivateFieldLooseKey("onResult");

var _onAssemblyFinished = /*#__PURE__*/_classPrivateFieldLooseKey("onAssemblyFinished");

var _cancelAssembly = /*#__PURE__*/_classPrivateFieldLooseKey("cancelAssembly");

var _onCancelAll = /*#__PURE__*/_classPrivateFieldLooseKey("onCancelAll");

var _getPersistentData = /*#__PURE__*/_classPrivateFieldLooseKey("getPersistentData");

var _onRestored = /*#__PURE__*/_classPrivateFieldLooseKey("onRestored");

var _connectAssembly = /*#__PURE__*/_classPrivateFieldLooseKey("connectAssembly");

var _prepareUpload = /*#__PURE__*/_classPrivateFieldLooseKey("prepareUpload");

var _afterUpload = /*#__PURE__*/_classPrivateFieldLooseKey("afterUpload");

var _closeAssemblyIfExists = /*#__PURE__*/_classPrivateFieldLooseKey("closeAssemblyIfExists");

var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");

var _onTusError = /*#__PURE__*/_classPrivateFieldLooseKey("onTusError");

var Transloadit = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Transloadit, _BasePlugin);

  var _super = _createSuper(Transloadit);

  /** @deprecated use `import { COMPANION_URL } from '@uppy/transloadit'` instead. */

  /** @deprecated use `import { COMPANION_ALLOWED_HOSTS } from '@uppy/transloadit'` instead. */
  function Transloadit(uppy, opts) {
    var _this2;

    _classCallCheck(this, Transloadit);

    var _this, _this$opts, _this$opts$assemblyOp, _this$opts$getAssembl;

    _this2 = _super.call(this, uppy, opts);
    _this = _assertThisInitialized(_this2);
    Object.defineProperty(_assertThisInitialized(_this2), _connectAssembly, {
      value: _connectAssembly2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _cancelAssembly, {
      value: _cancelAssembly2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onAssemblyFinished, {
      value: _onAssemblyFinished2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onResult, {
      value: _onResult2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onFileUploadComplete, {
      value: _onFileUploadComplete2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _findFile, {
      value: _findFile2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _reserveFiles, {
      value: _reserveFiles2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _shouldWaitAfterUpload, {
      value: _shouldWaitAfterUpload2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _createAssemblyWatcher, {
      value: _createAssemblyWatcher2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _createAssembly, {
      value: _createAssembly2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _attachAssemblyMetadata, {
      value: _attachAssemblyMetadata2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getClientVersion, {
      value: _getClientVersion2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _rateLimitedQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onFileUploadURLAvailable, {
      writable: true,
      value: function value(rawFile) {
        var _file$transloadit;

        var file = _this2.uppy.getFile(rawFile.id);

        if (!(file != null && (_file$transloadit = file.transloadit) != null && _file$transloadit.assembly)) {
          return;
        }

        var _this2$getPluginState = _this2.getPluginState(),
            assemblies = _this2$getPluginState.assemblies;

        var assembly = assemblies[file.transloadit.assembly];

        _this2.client.addFile(assembly, file).catch(function (err) {
          _this2.uppy.log(err);

          _this2.uppy.emit('transloadit:import-error', assembly, file.id, err);
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onCancelAll, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp) {
          var _ref3, reason, _this$getPluginState, uploadsAssemblies, assemblyIDs, assemblies;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _ref3 = _temp === void 0 ? {} : _temp, reason = _ref3.reason;
                  _context.prev = 1;

                  if (!(reason !== 'user')) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return");

                case 4:
                  _this$getPluginState = _this.getPluginState(), uploadsAssemblies = _this$getPluginState.uploadsAssemblies;
                  assemblyIDs = Object.values(uploadsAssemblies).flat(1);
                  assemblies = assemblyIDs.map(function (assemblyID) {
                    return _this.getAssembly(assemblyID);
                  });
                  _context.next = 9;
                  return Promise.all(assemblies.map(function (assembly) {
                    return _classPrivateFieldLooseBase(_this, _cancelAssembly)[_cancelAssembly](assembly);
                  }));

                case 9:
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);

                  _this.uppy.log(_context.t0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 11]]);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getPersistentData, {
      writable: true,
      value: function value(setData) {
        var _this2$getPluginState2 = _this2.getPluginState(),
            assemblies = _this2$getPluginState2.assemblies,
            uploadsAssemblies = _this2$getPluginState2.uploadsAssemblies;

        setData(_defineProperty({}, _this2.id, {
          assemblies: assemblies,
          uploadsAssemblies: uploadsAssemblies
        }));
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onRestored, {
      writable: true,
      value: function value(pluginData) {
        var savedState = pluginData && pluginData[_this2.id] ? pluginData[_this2.id] : {};
        var previousAssemblies = savedState.assemblies || {};
        var uploadsAssemblies = savedState.uploadsAssemblies || {};

        if (Object.keys(uploadsAssemblies).length === 0) {
          // Nothing to restore.
          return;
        } // Convert loaded Assembly statuses to a Transloadit plugin state object.


        var restoreState = function restoreState(assemblies) {
          var files = {};
          var results = [];

          var _loop = function _loop() {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                id = _Object$entries$_i[0],
                status = _Object$entries$_i[1];

            status.uploads.forEach(function (uploadedFile) {
              var file = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _findFile)[_findFile](uploadedFile);

              files[uploadedFile.id] = {
                id: file.id,
                assembly: id,
                uploadedFile: uploadedFile
              };
            });

            var state = _this2.getPluginState();

            Object.keys(status.results).forEach(function (stepName) {
              var _iterator = _createForOfIteratorHelper(status.results[stepName]),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var result = _step.value;
                  var file = state.files[result.original_id];
                  result.localId = file ? file.id : null;
                  results.push({
                    id: result.id,
                    result: result,
                    stepName: stepName,
                    assembly: id
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            });
          };

          for (var _i = 0, _Object$entries = Object.entries(assemblies); _i < _Object$entries.length; _i++) {
            _loop();
          }

          _this2.setPluginState({
            assemblies: assemblies,
            files: files,
            results: results,
            uploadsAssemblies: uploadsAssemblies
          });
        }; // Set up the Assembly instances and AssemblyWatchers for existing Assemblies.


        var restoreAssemblies = function restoreAssemblies() {
          // eslint-disable-next-line no-shadow
          var _this2$getPluginState3 = _this2.getPluginState(),
              assemblies = _this2$getPluginState3.assemblies,
              uploadsAssemblies = _this2$getPluginState3.uploadsAssemblies; // Set up the assembly watchers again for all the ongoing uploads.


          Object.keys(uploadsAssemblies).forEach(function (uploadID) {
            var assemblyIDs = uploadsAssemblies[uploadID];

            _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _createAssemblyWatcher)[_createAssemblyWatcher](assemblyIDs, uploadID);
          });
          var allAssemblyIDs = Object.keys(assemblies);
          allAssemblyIDs.forEach(function (id) {
            var assembly = new Assembly(assemblies[id], _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _rateLimitedQueue)[_rateLimitedQueue]);

            _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _connectAssembly)[_connectAssembly](assembly);
          });
        }; // Force-update all Assemblies to check for missed events.


        var updateAssemblies = function updateAssemblies() {
          var _this2$getPluginState4 = _this2.getPluginState(),
              assemblies = _this2$getPluginState4.assemblies;

          return Promise.all(Object.keys(assemblies).map(function (id) {
            return _this2.activeAssemblies[id].update();
          }));
        }; // Restore all Assembly state.


        _this2.restored = Promise.resolve().then(function () {
          restoreState(previousAssemblies);
          restoreAssemblies();
          return updateAssemblies();
        });

        _this2.restored.then(function () {
          _this2.restored = null;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _prepareUpload, {
      writable: true,
      value: function value(fileIDs, uploadID) {
        var files = fileIDs.map(function (id) {
          return _this2.uppy.getFile(id);
        });
        var filesWithoutErrors = files.filter(function (file) {
          if (!file.error) {
            _this2.uppy.emit('preprocess-progress', file, {
              mode: 'indeterminate',
              message: _this2.i18n('creatingAssembly')
            });

            return true;
          }

          return false;
        }); // eslint-disable-next-line no-shadow

        var createAssembly = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
            var fileIDs, options, assembly;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    fileIDs = _ref.fileIDs, options = _ref.options;
                    _context2.prev = 1;
                    _context2.next = 4;
                    return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _createAssembly)[_createAssembly](fileIDs, uploadID, options);

                  case 4:
                    assembly = _context2.sent;

                    if (!_this2.opts.importFromUploadURLs) {
                      _context2.next = 8;
                      break;
                    }

                    _context2.next = 8;
                    return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _reserveFiles)[_reserveFiles](assembly, fileIDs);

                  case 8:
                    fileIDs.forEach(function (fileID) {
                      var file = _this2.uppy.getFile(fileID);

                      _this2.uppy.emit('preprocess-complete', file);
                    });
                    return _context2.abrupt("return", assembly);

                  case 12:
                    _context2.prev = 12;
                    _context2.t0 = _context2["catch"](1);
                    fileIDs.forEach(function (fileID) {
                      var file = _this2.uppy.getFile(fileID); // Clear preprocessing state when the Assembly could not be created,
                      // otherwise the UI gets confused about the lingering progress keys


                      _this2.uppy.emit('preprocess-complete', file);

                      _this2.uppy.emit('upload-error', file, _context2.t0);
                    });
                    throw _context2.t0;

                  case 16:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[1, 12]]);
          }));

          return function createAssembly(_x2) {
            return _ref4.apply(this, arguments);
          };
        }();

        var _this2$getPluginState5 = _this2.getPluginState(),
            uploadsAssemblies = _this2$getPluginState5.uploadsAssemblies;

        _this2.setPluginState({
          uploadsAssemblies: _objectSpread(_objectSpread({}, uploadsAssemblies), {}, _defineProperty({}, uploadID, []))
        });

        var assemblyOptions = new AssemblyOptions(filesWithoutErrors, _this2.opts);
        return assemblyOptions.build().then(function (assemblies) {
          return Promise.all(assemblies.map(createAssembly));
        }).then(function (maybeCreatedAssemblies) {
          var createdAssemblies = maybeCreatedAssemblies.filter(Boolean);
          var assemblyIDs = createdAssemblies.map(function (assembly) {
            return assembly.status.assembly_id;
          });

          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _createAssemblyWatcher)[_createAssemblyWatcher](assemblyIDs, uploadID);

          return Promise.all(createdAssemblies.map(function (assembly) {
            return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _connectAssembly)[_connectAssembly](assembly);
          }));
        }) // If something went wrong before any Assemblies could be created,
        // clear all processing state.
        .catch(function (err) {
          filesWithoutErrors.forEach(function (file) {
            _this2.uppy.emit('preprocess-complete', file);

            _this2.uppy.emit('upload-error', file, err);
          });
          throw err;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _afterUpload, {
      writable: true,
      value: function value(fileIDs, uploadID) {
        var files = fileIDs.map(function (fileID) {
          return _this2.uppy.getFile(fileID);
        }); // Only use files without errors

        var filteredFileIDs = files.filter(function (file) {
          return !file.error;
        }).map(function (file) {
          return file.id;
        });

        var state = _this2.getPluginState(); // If we're still restoring state, wait for that to be done.


        if (_this2.restored) {
          return _this2.restored.then(function () {
            return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _afterUpload)[_afterUpload](filteredFileIDs, uploadID);
          });
        }

        var assemblyIDs = state.uploadsAssemblies[uploadID];

        var closeSocketConnections = function closeSocketConnections() {
          assemblyIDs.forEach(function (assemblyID) {
            var assembly = _this2.activeAssemblies[assemblyID];
            assembly.close();
            delete _this2.activeAssemblies[assemblyID];
          });
        }; // If we don't have to wait for encoding metadata or results, we can close
        // the socket immediately and finish the upload.


        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _shouldWaitAfterUpload)[_shouldWaitAfterUpload]()) {
          closeSocketConnections();
          var assemblies = assemblyIDs.map(function (id) {
            return _this2.getAssembly(id);
          });

          _this2.uppy.addResultData(uploadID, {
            transloadit: assemblies
          });

          return Promise.resolve();
        } // If no Assemblies were created for this upload, we also do not have to wait.
        // There's also no sockets or anything to close, so just return immediately.


        if (assemblyIDs.length === 0) {
          _this2.uppy.addResultData(uploadID, {
            transloadit: []
          });

          return Promise.resolve();
        }

        var incompleteFiles = files.filter(function (file) {
          return !hasProperty(_this2.completedFiles, file.id);
        });
        incompleteFiles.forEach(function (file) {
          _this2.uppy.emit('postprocess-progress', file, {
            mode: 'indeterminate',
            message: _this2.i18n('encoding')
          });
        });
        var watcher = _this2.assemblyWatchers[uploadID];
        return watcher.promise.then(function () {
          closeSocketConnections();
          var assemblies = assemblyIDs.map(function (id) {
            return _this2.getAssembly(id);
          }); // Remove the Assembly ID list for this upload,
          // it's no longer going to be used anywhere.

          var uploadsAssemblies = _objectSpread({}, _this2.getPluginState().uploadsAssemblies);

          delete uploadsAssemblies[uploadID];

          _this2.setPluginState({
            uploadsAssemblies: uploadsAssemblies
          });

          _this2.uppy.addResultData(uploadID, {
            transloadit: assemblies
          });
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _closeAssemblyIfExists, {
      writable: true,
      value: function value(assemblyID) {
        var _this$activeAssemblie;

        (_this$activeAssemblie = _this2.activeAssemblies[assemblyID]) == null ? void 0 : _this$activeAssemblie.close();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onError, {
      writable: true,
      value: function value(err, uploadID) {
        if (err === void 0) {
          err = null;
        }

        var state = _this.getPluginState();

        var assemblyIDs = state.uploadsAssemblies[uploadID];
        assemblyIDs == null ? void 0 : assemblyIDs.forEach(_classPrivateFieldLooseBase(_this, _closeAssemblyIfExists)[_closeAssemblyIfExists]);

        _this.client.submitError(err) // if we can't report the error that sucks
        .catch(sendErrorToConsole(err));
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onTusError, {
      writable: true,
      value: function value(file, err) {
        var _file$transloadit2, _err$message;

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _closeAssemblyIfExists)[_closeAssemblyIfExists](file == null ? void 0 : (_file$transloadit2 = file.transloadit) == null ? void 0 : _file$transloadit2.assembly);

        if (err != null && (_err$message = err.message) != null && _err$message.startsWith('tus: ')) {
          var _err$originalRequest, _err$originalRequest$;

          var endpoint = (_err$originalRequest = err.originalRequest) == null ? void 0 : (_err$originalRequest$ = _err$originalRequest.getUnderlyingObject()) == null ? void 0 : _err$originalRequest$.responseURL;

          _this2.client.submitError(err, {
            endpoint: endpoint,
            type: 'TUS_ERROR'
          }) // if we can't report the error that sucks
          .catch(sendErrorToConsole(err));
        }
      }
    });
    _this2.type = 'uploader';
    _this2.id = _this2.opts.id || 'Transloadit';
    _this2.title = 'Transloadit';
    _this2.defaultLocale = locale;
    var defaultOptions = {
      service: 'https://api2.transloadit.com',
      errorReporting: true,
      waitForEncoding: false,
      waitForMetadata: false,
      alwaysRunAssembly: false,
      importFromUploadURLs: false,

      /** @deprecated use `assemblyOptions` instead */
      signature: null,

      /** @deprecated use `assemblyOptions` instead */
      params: null,

      /** @deprecated use `assemblyOptions` instead */
      fields: null,

      /** @deprecated use `assemblyOptions` instead */
      getAssemblyOptions: null,
      limit: 20,
      retryDelays: [7000, 10000, 15000, 20000]
    };
    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // TODO: remove this fallback in the next major

    (_this$opts$assemblyOp = (_this$opts = _this2.opts).assemblyOptions) != null ? _this$opts$assemblyOp : _this$opts.assemblyOptions = (_this$opts$getAssembl = _this2.opts.getAssemblyOptions) != null ? _this$opts$getAssembl : {
      params: _this2.opts.params,
      signature: _this2.opts.signature,
      fields: _this2.opts.fields
    }; // TODO: remove this check in the next major (validating params when creating the assembly should be enough)

    if ((opts == null ? void 0 : opts.params) != null && opts.getAssemblyOptions == null && opts.assemblyOptions == null) {
      validateParams(_this2.opts.assemblyOptions.params);
    }

    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _rateLimitedQueue)[_rateLimitedQueue] = new RateLimitedQueue(_this2.opts.limit);

    _this2.i18nInit();

    _this2.client = new Client({
      service: _this2.opts.service,
      client: _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getClientVersion)[_getClientVersion](),
      errorReporting: _this2.opts.errorReporting,
      rateLimitedQueue: _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _rateLimitedQueue)[_rateLimitedQueue]
    }); // Contains Assembly instances for in-progress Assemblies.

    _this2.activeAssemblies = {}; // Contains a mapping of uploadID to AssemblyWatcher

    _this2.assemblyWatchers = {}; // Contains a file IDs that have completed postprocessing before the upload
    // they belong to has entered the postprocess stage.

    _this2.completedFiles = Object.create(null);
    return _this2;
  }

  _createClass(Transloadit, [{
    key: "install",
    value: function install() {
      this.uppy.addPreProcessor(_classPrivateFieldLooseBase(this, _prepareUpload)[_prepareUpload]);
      this.uppy.addPostProcessor(_classPrivateFieldLooseBase(this, _afterUpload)[_afterUpload]); // We may need to close socket.io connections on error.

      this.uppy.on('error', _classPrivateFieldLooseBase(this, _onError)[_onError]); // Handle cancellation.

      this.uppy.on('cancel-all', _classPrivateFieldLooseBase(this, _onCancelAll)[_onCancelAll]); // For error reporting.

      this.uppy.on('upload-error', _classPrivateFieldLooseBase(this, _onTusError)[_onTusError]);

      if (this.opts.importFromUploadURLs) {
        // No uploader needed when importing; instead we take the upload URL from an existing uploader.
        this.uppy.on('upload-success', _classPrivateFieldLooseBase(this, _onFileUploadURLAvailable)[_onFileUploadURLAvailable]);
      } else {
        this.uppy.use(Tus, {
          // Disable tus-js-client fingerprinting, otherwise uploading the same file at different times
          // will upload to an outdated Assembly, and we won't get socket events for it.
          //
          // To resume a Transloadit upload, we need to reconnect to the websocket, and the state that's
          // required to do that is not saved by tus-js-client's fingerprinting. We need the tus URL,
          // the Assembly URL, and the WebSocket URL, at least. We also need to know _all_ the files that
          // were added to the Assembly, so we can properly complete it. All that state is handled by
          // Golden Retriever. So, Golden Retriever is required to do resumability with the Transloadit plugin,
          // and we disable Tus's default resume implementation to prevent bad behaviours.
          storeFingerprintForResuming: false,
          // Disable Companion's retry optimisation; we need to change the endpoint on retry
          // so it can't just reuse the same tus.Upload instance server-side.
          useFastRemoteRetry: false,
          // Only send Assembly metadata to the tus endpoint.
          allowedMetaFields: ['assembly_url', 'filename', 'fieldname'],
          // Pass the limit option to @uppy/tus
          limit: this.opts.limit,
          rateLimitedQueue: _classPrivateFieldLooseBase(this, _rateLimitedQueue)[_rateLimitedQueue],
          retryDelays: this.opts.retryDelays
        });
      }

      this.uppy.on('restore:get-data', _classPrivateFieldLooseBase(this, _getPersistentData)[_getPersistentData]);
      this.uppy.on('restored', _classPrivateFieldLooseBase(this, _onRestored)[_onRestored]);
      this.setPluginState({
        // Contains Assembly status objects, indexed by their ID.
        assemblies: {},
        // Contains arrays of Assembly IDs, indexed by the upload ID that they belong to.
        uploadsAssemblies: {},
        // Contains file data from Transloadit, indexed by their Transloadit-assigned ID.
        files: {},
        // Contains result data from Transloadit.
        results: []
      }); // We cannot cancel individual files because Assemblies tend to contain many files.

      var _this$uppy$getState = this.uppy.getState(),
          capabilities = _this$uppy$getState.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          individualCancellation: false
        })
      });
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.removePreProcessor(_classPrivateFieldLooseBase(this, _prepareUpload)[_prepareUpload]);
      this.uppy.removePostProcessor(_classPrivateFieldLooseBase(this, _afterUpload)[_afterUpload]);
      this.uppy.off('error', _classPrivateFieldLooseBase(this, _onError)[_onError]);

      if (this.opts.importFromUploadURLs) {
        this.uppy.off('upload-success', _classPrivateFieldLooseBase(this, _onFileUploadURLAvailable)[_onFileUploadURLAvailable]);
      }

      var _this$uppy$getState2 = this.uppy.getState(),
          capabilities = _this$uppy$getState2.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          individualCancellation: true
        })
      });
    }
  }, {
    key: "getAssembly",
    value: function getAssembly(id) {
      var _this$getPluginState2 = this.getPluginState(),
          assemblies = _this$getPluginState2.assemblies;

      return assemblies[id];
    }
  }, {
    key: "getAssemblyFiles",
    value: function getAssemblyFiles(assemblyID) {
      return this.uppy.getFiles().filter(function (file) {
        var _file$transloadit3;

        return (file == null ? void 0 : (_file$transloadit3 = file.transloadit) == null ? void 0 : _file$transloadit3.assembly) === assemblyID;
      });
    }
  }]);

  return Transloadit;
}(BasePlugin);

export { Transloadit as default };

function _getClientVersion2() {
  var _this3 = this;

  var list = ["uppy-core:".concat(this.uppy.constructor.VERSION), "uppy-transloadit:".concat(this.constructor.VERSION), "uppy-tus:".concat(Tus.VERSION)];

  var addPluginVersion = function addPluginVersion(pluginName, versionName) {
    var plugin = _this3.uppy.getPlugin(pluginName);

    if (plugin) {
      list.push("".concat(versionName, ":").concat(plugin.constructor.VERSION));
    }
  };

  if (this.opts.importFromUploadURLs) {
    addPluginVersion('XHRUpload', 'uppy-xhr-upload');
    addPluginVersion('AwsS3', 'uppy-aws-s3');
    addPluginVersion('AwsS3Multipart', 'uppy-aws-s3-multipart');
  }

  addPluginVersion('Dropbox', 'uppy-dropbox');
  addPluginVersion('Box', 'uppy-box');
  addPluginVersion('Facebook', 'uppy-facebook');
  addPluginVersion('GoogleDrive', 'uppy-google-drive');
  addPluginVersion('Instagram', 'uppy-instagram');
  addPluginVersion('OneDrive', 'uppy-onedrive');
  addPluginVersion('Zoom', 'uppy-zoom');
  addPluginVersion('Url', 'uppy-url');
  return list.join(',');
}

function _attachAssemblyMetadata2(file, status) {
  // Add the metadata parameters Transloadit needs.
  var meta = _objectSpread(_objectSpread({}, file.meta), {}, {
    assembly_url: status.assembly_url,
    filename: file.name,
    fieldname: 'file'
  }); // Add Assembly-specific Tus endpoint.


  var tus = _objectSpread(_objectSpread({}, file.tus), {}, {
    endpoint: status.tus_url,
    // Include X-Request-ID headers for better debugging.
    addRequestId: true
  }); // Set Companion location. We only add this, if 'file' has the attribute
  // remote, because this is the criteria to identify remote files.
  // We only replace the hostname for Transloadit's companions, so that
  // people can also self-host them while still using Transloadit for encoding.


  var remote = file.remote;

  if (file.remote && TL_COMPANION.test(file.remote.companionUrl)) {
    var newHost = status.companion_url.replace(/\/$/, '');
    var path = file.remote.url.replace(file.remote.companionUrl, '').replace(/^\//, '');
    remote = _objectSpread(_objectSpread({}, file.remote), {}, {
      companionUrl: newHost,
      url: "".concat(newHost, "/").concat(path)
    });
  } // Store the Assembly ID this file is in on the file under the `transloadit` key.


  var newFile = _objectSpread(_objectSpread({}, file), {}, {
    transloadit: {
      assembly: status.assembly_id
    }
  }); // Only configure the Tus plugin if we are uploading straight to Transloadit (the default).


  if (!this.opts.importFromUploadURLs) {
    Object.assign(newFile, {
      meta: meta,
      tus: tus,
      remote: remote
    });
  }

  return newFile;
}

function _createAssembly2(fileIDs, uploadID, options) {
  var _this4 = this;

  this.uppy.log('[Transloadit] Create Assembly');
  return this.client.createAssembly({
    params: options.params,
    fields: options.fields,
    expectedFiles: fileIDs.length,
    signature: options.signature
  }).then( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(newAssembly) {
      var files, assembly, status, assemblyID, _this4$getPluginState, assemblies, uploadsAssemblies, updatedFiles, fileRemovedHandler;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              files = _this4.uppy.getFiles().filter(function (_ref2) {
                var id = _ref2.id;
                return fileIDs.includes(id);
              });

              if (!(files.length !== fileIDs.length)) {
                _context3.next = 8;
                break;
              }

              if (!(files.length === 0)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return _this4.client.cancelAssembly(newAssembly);

            case 5:
              return _context3.abrupt("return", null);

            case 6:
              _context3.next = 8;
              return _this4.client.updateNumberOfFilesInAssembly(newAssembly, files.length);

            case 8:
              assembly = new Assembly(newAssembly, _classPrivateFieldLooseBase(_this4, _rateLimitedQueue)[_rateLimitedQueue]);
              status = assembly.status;
              assemblyID = status.assembly_id;
              _this4$getPluginState = _this4.getPluginState(), assemblies = _this4$getPluginState.assemblies, uploadsAssemblies = _this4$getPluginState.uploadsAssemblies;

              _this4.setPluginState({
                // Store the Assembly status.
                assemblies: _objectSpread(_objectSpread({}, assemblies), {}, _defineProperty({}, assemblyID, status)),
                // Store the list of Assemblies related to this upload.
                uploadsAssemblies: _objectSpread(_objectSpread({}, uploadsAssemblies), {}, _defineProperty({}, uploadID, [].concat(_toConsumableArray(uploadsAssemblies[uploadID]), [assemblyID])))
              });

              updatedFiles = {};
              files.forEach(function (file) {
                updatedFiles[file.id] = _classPrivateFieldLooseBase(_this4, _attachAssemblyMetadata)[_attachAssemblyMetadata](file, status);
              });

              _this4.uppy.setState({
                files: _objectSpread(_objectSpread({}, _this4.uppy.getState().files), updatedFiles)
              });

              fileRemovedHandler = function fileRemovedHandler(fileRemoved, reason) {
                if (reason === 'cancel-all') {
                  assembly.close();

                  _this4.uppy.off(fileRemovedHandler);
                } else if (fileRemoved.id in updatedFiles) {
                  delete updatedFiles[fileRemoved.id];
                  var nbOfRemainingFiles = Object.keys(updatedFiles).length;

                  if (nbOfRemainingFiles === 0) {
                    assembly.close();

                    _classPrivateFieldLooseBase(_this4, _cancelAssembly)[_cancelAssembly](newAssembly).catch(function () {
                      /* ignore potential errors */
                    });

                    _this4.uppy.off(fileRemovedHandler);
                  } else {
                    _this4.client.updateNumberOfFilesInAssembly(newAssembly, nbOfRemainingFiles).catch(function () {
                      /* ignore potential errors */
                    });
                  }
                }
              };

              _this4.uppy.on('file-removed', fileRemovedHandler);

              _this4.uppy.emit('transloadit:assembly-created', status, fileIDs);

              _this4.uppy.log("[Transloadit] Created Assembly ".concat(assemblyID));

              return _context3.abrupt("return", assembly);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }()).catch(function (err) {
    var wrapped = new ErrorWithCause("".concat(_this4.i18n('creatingAssemblyFailed'), ": ").concat(err.message), {
      cause: err
    });

    if ('details' in err) {
      wrapped.details = err.details;
    }

    if ('assembly' in err) {
      wrapped.assembly = err.assembly;
    }

    throw wrapped;
  });
}

function _createAssemblyWatcher2(assemblyID, uploadID) {
  var _this5 = this;

  // AssemblyWatcher tracks completion states of all Assemblies in this upload.
  var watcher = new AssemblyWatcher(this.uppy, assemblyID);
  watcher.on('assembly-complete', function (id) {
    var files = _this5.getAssemblyFiles(id);

    files.forEach(function (file) {
      _this5.completedFiles[file.id] = true;

      _this5.uppy.emit('postprocess-complete', file);
    });
  });
  watcher.on('assembly-error', function (id, error) {
    // Clear postprocessing state for all our files.
    var files = _this5.getAssemblyFiles(id);

    files.forEach(function (file) {
      // TODO Maybe make a postprocess-error event here?
      _this5.uppy.emit('upload-error', file, error);

      _this5.uppy.emit('postprocess-complete', file);
    });
  });
  this.assemblyWatchers[uploadID] = watcher;
}

function _shouldWaitAfterUpload2() {
  return this.opts.waitForEncoding || this.opts.waitForMetadata;
}

function _reserveFiles2(assembly, fileIDs) {
  var _this6 = this;

  return Promise.all(fileIDs.map(function (fileID) {
    var file = _this6.uppy.getFile(fileID);

    return _this6.client.reserveFile(assembly.status, file);
  }));
}

function _findFile2(uploadedFile) {
  var files = this.uppy.getFiles();

  for (var i = 0; i < files.length; i++) {
    var file = files[i]; // Completed file upload.

    if (file.uploadURL === uploadedFile.tus_upload_url) {
      return file;
    } // In-progress file upload.


    if (file.tus && file.tus.uploadUrl === uploadedFile.tus_upload_url) {
      return file;
    }

    if (!uploadedFile.is_tus_file) {
      // Fingers-crossed check for non-tus uploads, eg imported from S3.
      if (file.name === uploadedFile.name && file.size === uploadedFile.size) {
        return file;
      }
    }
  }

  return undefined;
}

function _onFileUploadComplete2(assemblyId, uploadedFile) {
  var state = this.getPluginState();

  var file = _classPrivateFieldLooseBase(this, _findFile)[_findFile](uploadedFile);

  if (!file) {
    this.uppy.log('[Transloadit] Couldn’t file the file, it was likely removed in the process');
    return;
  }

  this.setPluginState({
    files: _objectSpread(_objectSpread({}, state.files), {}, _defineProperty({}, uploadedFile.id, {
      assembly: assemblyId,
      id: file.id,
      uploadedFile: uploadedFile
    }))
  });
  this.uppy.emit('transloadit:upload', uploadedFile, this.getAssembly(assemblyId));
}

function _onResult2(assemblyId, stepName, result) {
  var state = this.getPluginState();
  var file = state.files[result.original_id]; // The `file` may not exist if an import robot was used instead of a file upload.

  result.localId = file ? file.id : null; // eslint-disable-line no-param-reassign

  var entry = {
    result: result,
    stepName: stepName,
    id: result.id,
    assembly: assemblyId
  };
  this.setPluginState({
    results: [].concat(_toConsumableArray(state.results), [entry])
  });
  this.uppy.emit('transloadit:result', stepName, result, this.getAssembly(assemblyId));
}

function _onAssemblyFinished2(status) {
  var _this7 = this;

  var url = status.assembly_ssl_url;
  this.client.getAssemblyStatus(url).then(function (finalStatus) {
    var assemblyId = finalStatus.assembly_id;

    var state = _this7.getPluginState();

    _this7.setPluginState({
      assemblies: _objectSpread(_objectSpread({}, state.assemblies), {}, _defineProperty({}, assemblyId, finalStatus))
    });

    _this7.uppy.emit('transloadit:complete', finalStatus);
  });
}

function _cancelAssembly2(_x4) {
  return _cancelAssembly3.apply(this, arguments);
}

function _cancelAssembly3() {
  _cancelAssembly3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(assembly) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.client.cancelAssembly(assembly);

          case 2:
            // TODO bubble this through AssemblyWatcher so its event handlers can clean up correctly
            this.uppy.emit('transloadit:assembly-cancelled', assembly);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _cancelAssembly3.apply(this, arguments);
}

function _connectAssembly2(assembly) {
  var _this8 = this;

  var status = assembly.status;
  var id = status.assembly_id;
  this.activeAssemblies[id] = assembly; // Sync local `assemblies` state

  assembly.on('status', function (newStatus) {
    var _this8$getPluginState = _this8.getPluginState(),
        assemblies = _this8$getPluginState.assemblies;

    _this8.setPluginState({
      assemblies: _objectSpread(_objectSpread({}, assemblies), {}, _defineProperty({}, id, newStatus))
    });
  });
  assembly.on('upload', function (file) {
    _classPrivateFieldLooseBase(_this8, _onFileUploadComplete)[_onFileUploadComplete](id, file);
  });
  assembly.on('error', function (error) {
    error.assembly = assembly.status; // eslint-disable-line no-param-reassign

    _this8.uppy.emit('transloadit:assembly-error', assembly.status, error);
  });
  assembly.on('executing', function () {
    _this8.uppy.emit('transloadit:assembly-executing', assembly.status);
  });

  if (this.opts.waitForEncoding) {
    assembly.on('result', function (stepName, result) {
      _classPrivateFieldLooseBase(_this8, _onResult)[_onResult](id, stepName, result);
    });
  }

  if (this.opts.waitForEncoding) {
    assembly.on('finished', function () {
      _classPrivateFieldLooseBase(_this8, _onAssemblyFinished)[_onAssemblyFinished](assembly.status);
    });
  } else if (this.opts.waitForMetadata) {
    assembly.on('metadata', function () {
      _classPrivateFieldLooseBase(_this8, _onAssemblyFinished)[_onAssemblyFinished](assembly.status);
    });
  } // No need to connect to the socket if the Assembly has completed by now.


  if (assembly.ok === 'ASSEMBLY_COMPLETE') {
    return assembly;
  }

  assembly.connect();
  return assembly;
}

Transloadit.VERSION = packageJson.version;
Transloadit.COMPANION = COMPANION_URL;
Transloadit.COMPANION_PATTERN = COMPANION_ALLOWED_HOSTS;
export { COMPANION_URL, COMPANION_ALLOWED_HOSTS };